// SAFE-WRITE-BEGIN: frontend/src/api/platformHandoff.ts
// PLAT-ADMIN-HANDOFF-1 — one-time sign-in from the Valuation site to the platform hub.
// The code only ever lives in a URL fragment and in these request bodies; it is never logged.
import { apiClient } from '@/api/client'

export const HANDOFF_INVALID_MESSAGE = 'This sign-in link is no longer valid. Sign in on the platform site.'

/** Valuation site, super_admin: the platform URL (code in its fragment), or null when the
 * hand-off is off or fails — the caller then opens the plain platform sign-in address. */
export async function startHandoff(): Promise<string | null> {
  try {
    const { data } = await apiClient.post<{ url: string }>('/v1/platform-handoff/start')
    return typeof data?.url === 'string' && data.url.startsWith('https://') ? data.url : null
  } catch {
    return null
  }
}

/** Platform site, nobody signed in: the email the code would sign in. Throws if the code is no good. */
export async function previewHandoff(code: string): Promise<string> {
  const { data } = await apiClient.post<{ email: string }>('/v1/platform-handoff/preview', { code })
  return data.email
}

/** Platform site, on the person's click: spends the code and sets the session cookies. Returns the
 * server's redirect, which the page ignores: it always goes to /hub. */
export async function redeemHandoff(code: string): Promise<string> {
  const { data } = await apiClient.post<{ redirect: string }>('/v1/platform-handoff/redeem', { code })
  return data.redirect
}
// SAFE-WRITE-EOF: frontend/src/api/platformHandoff.ts
